<div *ngIf="dialogButton" class="w-100 text-center mt-2 mb-2">
  <button mat-raised-button (click)="openSubmitDialog()" color="primary"><mat-icon class="mr-1">rate_review</mat-icon>Leave Your Own Review</button>
</div>
<div class="reviews" *ngIf="product?.reviews">
  <div class="h-100 py-1 mb-1" *ngFor="let review of product?.reviews">
    <div class="d-flex flex-row flex-wrap justify-content-start align-items-center">
      <div class="flex-100 h4">{{review.title}}</div>
      <div class="flex-100">
        <app-rating [large]="true" [review]="review" [direction]="'row'"></app-rating>
      </div>
      <div class="flex-100">
        <p class="text-muted" [hidden]="true"><small>{{review.created | date : 'medium'}}</small></p>
        <p class="text">{{review.reviewText}}</p>
      </div>
      <div *ngIf="review.reviewerName || review.state" class="flex-100 reviewer">
        <span *ngIf="review.reviewerName">{{review.reviewerName}}&nbsp;</span>
        <span *ngIf="!review.reviewerName">Anonymous&nbsp;</span>
        <span *ngIf="review.state">from {{review.state.abbreviation}}</span>
        <span class="verified">
          <mat-icon>verified_user</mat-icon>Verified buyer
        </span>
      </div>
      <div class="flex-100 mt-1" *ngIf="review.replyText">
        <p class="text"><strong>We Said: </strong>{{review.replyText}}</p>
      </div>
    </div>
  </div>
</div>
